import moment from 'moment'

export const getDriverName = (drivers) =>
  drivers && drivers.length > 0 ? drivers[drivers.length - 1].name : ''

export const convertTrackingDriver = ({
  id,
  user,
  phone_number,
  driver,
  first_name,
  last_name,
  vehicle,
  preferred_areas,
  profile_photo,
}) => {
  const { id: vehicle_id, brand, model, plate_number } = vehicle || {}
  return {
    id: user || id,
    vehicle_id,
    avatar: profile_photo ? profile_photo.thumb_path : '',
    name: driver || `${first_name || ''} ${last_name || ''}`,
    phone_number,
    model: brand ? `${brand || ''} - ${model || ''}` : '',
    plate_number,
    schedule: preferred_areas || [],
  }
}

export const convertDriverLocation = ({
  lat,
  lng,
  name,
  avatar,
  ...props
}) => ({
  location: {
    lat: parseFloat(lat),
    lng: parseFloat(lng),
  },
  driver: name,
  ...props,
})

export const getTextArray = (text) => {
  const textArray = text.split(' ')
  if (textArray.length > 2) {
    const rs = Array(Math.round(textArray.length / 2)).fill('')
    textArray.forEach((item, index) => {
      if (index % 2 === 0) {
        rs[Math.floor(index / 2)] = item
      } else {
        rs[Math.floor(index / 2)] += ` ${item}`
      }
    })
    return rs
  }
  return [text]
}

export const calcFontSize = (text) => {
  if (text.length > 30) return 10
  if (text.length > 18) return 11
  return 13
}

export const calcTop = (len) => {
  if (len > 2) return 70
  if (len > 1) return 72
  return 76
}

export const getMapBound = (width) => {
  if (width < 1280) {
    return {
      top: 90,
      bottom: 20,
      right: 20,
      left: 20,
    }
  }
  return {
    top: 100,
    bottom: 100,
    right: 20,
    left: 20,
  }
}

export const convertTimeZone = (timezoneStr) => {
  try {
    const tz = moment.tz(timezoneStr)
    const offset = tz.utcOffset()
    const hours = offset / 60
    return `${hours >= 0 ? '+' : '-'}${Math.abs(hours)}`
  } catch (_error) {
    return 'Unknown timezone'
  }
}
